/* eslint-disable consistent-return */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-case-declarations */

// const initialState = { types: [] };
const initialState = {
  proceduresME: {},
  willBeGto: [],
  loadingProcedures: true
};

function cleanState(action) {
  if (!action.payload) return initialState;
  const cloned = { ...action.payload.procedures.details } || {};

  for (const key in cloned) {
    cloned[key].dataRealizacao = null;
  }

  return {
    ...action.payload.procedures,
    details: {
      ...cloned
    }
  };
}

export default (state = initialState, action) => {
  if(!action){
    return state;
  }
  switch (action.type) {
    case 'procedure/CREATE':
      return {
        ...state,
        details: {
          ...state.details,
          [action.payload.hash]: {
            ...action.payload
          }
        }
      };

    case 'procedure/EDIT':
      return {
        ...state,
        details: {
          ...state.details,
          [action.payload.hash]: {
            ...action.payload
          }
        }
      };

    case 'procedure/UPDATE_DATE':
      return {
        ...state,
        details: {
          ...state.details,
          [action.payload.item.hash]: {
            ...state.details[action.payload.item.hash],
            dataRealizacao: action.payload.date
          }
        }
      };

    case 'procedure/CONCLUDE':
      return {
        ...state,
        details: {
          ...state.details,
          ...action.payload
        }
      };

    case 'procedure/ADD_TYPES':
      return {
        ...state,
        types: [...action.payload]
      };

    case 'plans/OVERWRITE':
      return {
        ...state,
        ...action.payload.procedures
      };

    case 'procedure/LOAD_PROCEDURES_ME':
      return {
        ...state,
        proceduresME: {
          ...action.payload
        },
        willBeGto: []
      };

    case 'procedure/EDIT_PROCEDURES_ME':
      return {
        ...state,
        proceduresME: {
          ...state.proceduresME,
          procedures: action.payload
        }
      };

    case 'procedure/FALLBACK_TO_DEFAULT':
      return {
        ...state,
        proceduresME: {
          ...state.proceduresME,
          procedures: [...action.payload]
        }
      };

    case 'procedure/ADD_IMAGES':
      return {
        ...state,
        proceduresME: {
          ...state.proceduresME,
          procedures: [...action.payload]
        }
      };

    case 'procedure/REMOVE_IMAGES':
      return {
        ...state,
        proceduresME: {
          ...state.proceduresME,
          procedures: [...action.payload]
        }
      };

    case 'procedure/LOADING':
      return {
        ...state,
        loadingProcedures: action.payload
      };

    case 'procedure/CLEANWILLBEGTO':
      return {
        ...state,
        willBeGto: []
      };

    case 'procedure/ADDTOWILLBEGTO':
      return {
        ...state,
        willBeGto: action.payload
      };

    case 'procedure/REMOVE_FROM_WILLBEGTO':
      return {
        ...state,
        willBeGto: action.payload
      };

    case 'procedure/CLEAN':
      return {
        ...state,
        proceduresME: {}
      };

    case 'persist/REHYDRATE':
      return cleanState(action);

    default:
      return state;
  }
};
